import React from 'react';
import PageShell from './PageShell';

function ListPageLayout({
  title,
  subtitle,
  breadcrumbs = [],
  backTo,
  actions,
  error,
  children,
}) {
  return (
    <PageShell title={title} subtitle={subtitle} breadcrumbs={breadcrumbs} backTo={backTo} actions={actions}>
      {error && <div className="alert alert-danger">{error}</div>}
      {children}
    </PageShell>
  );
}

export default ListPageLayout;
